// Client-side mirror of the caller's effective permissions (from rpc my_permissions).
// USED ONLY FOR UX (what to show). Every action is re-authorized by RLS / server functions.

export function createPermissionSet(rows = []) {
  const map = new Map();
  for (const { permission_key: key, scope } of rows) {
    if (!map.has(key)) map.set(key, new Set());
    map.get(key).add(scope);
  }
  const can = (key, scope = 'org') => {
    const scopes = map.get(key);
    return Boolean(scopes && (scopes.has('org') || scopes.has(scope)));
  };
  return Object.freeze({
    can,
    canAny: (keys, scope) => keys.some((k) => can(k, scope)),
    canAll: (keys, scope) => keys.every((k) => can(k, scope)),
    keys: () => Array.from(map.keys()).sort(),
    entries: () => Array.from(map.entries()).map(([k, s]) => ({ key: k, scopes: Array.from(s) })),
    size: map.size,
  });
}

/** requirement: undefined | 'perm.key' | ['a','b'] (any of) | { all: [...] } */
export function satisfies(permissionSet, requirement) {
  if (!requirement) return true;
  if (!permissionSet) return false;
  if (typeof requirement === 'string') return permissionSet.can(requirement);
  if (Array.isArray(requirement)) return permissionSet.canAny(requirement);
  if (requirement.all) return permissionSet.canAll(requirement.all);
  return false;
}
